export function afterNextRender(callback: () => void): void {
  window.requestAnimationFrame((): void => {
    window.requestAnimationFrame((): void => {
      callback()
    })
  })
}
